import * as yup from 'yup';
import { errorMessages } from 'Config';

export const PaymentStepSchema = yup.object({
  // Payment method selection is handled by component state, not form validation
});

export type PaymentStepSchemaInputs = yup.InferType<typeof PaymentStepSchema>;

export const paymentStepSchemaInitialValues: InitialValues = {
  // No form fields needed for payment method selection
};

type InitialValues = {
  // Empty for now, payment method is handled by component state
};
